import { CHANGE_TABBAR_DYNAMIC_OPTION } from "./actionTypes";

export default (activeTabbar) => ({
  type: CHANGE_TABBAR_DYNAMIC_OPTION,
  payload: {
    activeTabbar
  }
});